import { ErrorOutline as ErrorOutlineIcon } from '@mui/icons-material';
import { StatusPage } from 'cleveron-web-components';
import React from 'react';

function Error404({ id }) {
    return (
        <StatusPage
            Icon={ErrorOutlineIcon}
            buttonLink="/"
            buttonTextKey="actions.goToFrontPage"
            id={id}
            textTopKey="error.notFoundText"
            titleKey="error.notFound"
        />
    );
}

export default Error404;
